module.exports = __webpack_public_path__ + "static/media/btn_wechat.60cac736.svg";